import { AxiosPromise } from 'axios';
import { EndPointService } from 'src/services/api-handlers/axios';

function getIncentives(params: any): AxiosPromise {
    return EndPointService.get('/incentives', { params });
}

function getIncentive(id: number | string): AxiosPromise {
    return EndPointService.get(`/incentives/${id}`);
}

function getProvidersIncentives(data: { dateFrom: string; dateTo: string; page: number }): AxiosPromise {
    return EndPointService.get(`/incentives/providers`, { params: data });
}

function deleteIncentive(id: number | string): AxiosPromise {
    return EndPointService.delete(`/incentives/${id}`);
}

function createIncentive(payload: any): AxiosPromise {
    return EndPointService.post('/incentives', {}, { params: payload });
}

function updateIncentive(id: number | string, payload: any): AxiosPromise {
    return EndPointService.put(`/incentives/${id}`, { ...payload });
}
function updateIncentiveStatus(id: number | string, payload: any): AxiosPromise {
    return EndPointService.put(`/incentives/status/paid/${id}`, { ...payload });
}
function getIncentiveBonuses(id: number | string, payload: any): AxiosPromise {
    return EndPointService.get(`/incentive_bonuses`, { params: { 'incentive.id': id } });
}

export default {
    getIncentives,
    getIncentiveBonuses,
    getProvidersIncentives,
    getIncentive,
    deleteIncentive,
    createIncentive,
    updateIncentive,
    updateIncentiveStatus,
};
